module.exports = __webpack_public_path__ + "static/media/download-icon.f936bcad.svg";